import { BROWSER_VIDEO_COST, LOCALE_TAGS } from '@bannermatic/core';
import { getLocale } from './i18n';

const INTL: Record<string, string> = LOCALE_TAGS;

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return '—';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
  return `${(bytes / 1024 / 1024 / 1024).toFixed(2)} GB`;
}

export function formatDate(value: string | Date | null | undefined, withTime = true): string {
  if (!value) return '—';
  const d = typeof value === 'string' ? new Date(value) : value;
  return d.toLocaleString(INTL[getLocale()], {
    day: 'numeric',
    month: 'short',
    year: d.getFullYear() === new Date().getFullYear() ? undefined : 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit' } : {}),
  });
}

export function formatRelative(value: string | Date | null | undefined): string {
  if (!value) return '—';
  const d = typeof value === 'string' ? new Date(value) : value;
  const diff = (Date.now() - d.getTime()) / 1000;
  const rtf = new Intl.RelativeTimeFormat(getLocale(), { numeric: 'auto' });
  if (Math.abs(diff) < 60) return rtf.format(-Math.round(diff), 'second');
  if (Math.abs(diff) < 3600) return rtf.format(-Math.round(diff / 60), 'minute');
  if (Math.abs(diff) < 86400) return rtf.format(-Math.round(diff / 3600), 'hour');
  if (Math.abs(diff) < 86400 * 7) return rtf.format(-Math.round(diff / 86400), 'day');
  return formatDate(d, false);
}

export function formatNumber(n: number): string {
  return new Intl.NumberFormat(INTL[getLocale()]).format(n);
}

/** Minutes of video for a number of seconds (one decimal at most). */
export function videoMin(seconds: number): string {
  return formatNumber(Math.round(seconds / 6) / 10);
}

/** Video allowance of a plan for the pricing cards: on our servers and on the user's computer. */
export function videoMinutes(seconds: number): { n: string; m: string } {
  return { n: videoMin(seconds), m: videoMin(seconds / BROWSER_VIDEO_COST) };
}

export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
